module.exports = __webpack_public_path__ + "static/media/white-tape-co-name-square.162e2db5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/white-tape-co-name-square.png
// module id = 500
// module chunks = 0